import { createBrowserRouter } from 'react-router-dom';
import BasicLayout from './layout/basiclayout';
import LandingPage from './pages/landingpage';
import ProductPage from './pages/productpage';
import CategoryPage from './pages/categorypage';
import RecentlyAddedPage from './pages/recentlyaddedpage';
import BrandPage from './pages/brandpage';
import BrandProductPage from './pages/brand-page/brandproductpage';
import BrandFormTable from './pages/addBrand';
import ProductFormWithVariants from './pages/addproduct';
import AboutUs from './pages/aboutuspage';
import ContactUs from './pages/contactuspage';
import MultiFileUploader from './pages/addbulkproduct';
import TermsAndConditions from './pages/tnc';
import PrivacyPolicy from './pages/privcypolicy';
import BlogPage from './pages/blogpage';
import ExcelProduct from './pages/excelproduct';
import UploadEcom from './pages/uploadecom';
import MyProfile from './pages/profile/myprofile';
import SearchPage from './pages/search/searchpage';
const Route = createBrowserRouter([
    {
        path:'/',
        element:<BasicLayout/>,
        children:[
            {index:true,element:<LandingPage/>},
            {path:'/product/:product',element:<ProductPage/>},
            {path:'/addbrand',element:<BrandFormTable/>},
            {path:'/addbulk',element:<MultiFileUploader/>},
            {path:'/addproduct',element:<ProductFormWithVariants/>},
            {path:'/category',element:<CategoryPage/>},
            {path:'/recently-added',element:<RecentlyAddedPage/>},
            {path:'/brand' ,
                children:[
                    {index:true,element:<BrandPage/>},
                    {path:':brandname',element:<BrandProductPage/>}
                ]
            },
            {path:'/aboutus',element:<AboutUs/>},
            {path:'/contactus',element:<ContactUs/>},
            // {path:'/blogs',element:<BlogPage/>},
            { path: '/privacy-policy', element: <PrivacyPolicy /> },
            { path: '/terms', element: <TermsAndConditions /> },
            {path:'/getproduct',element:<ExcelProduct/>},
            {path:'/uploadecom',element:<UploadEcom/>},
            {path:'/user',element:<MyProfile/>},
            {path:'/search',element:<SearchPage/>}

        ]
    }
])

export default Route